export const GraphColor = {
    TTM : '#0000FF',
    IMS : '#000000',
    MDR : '#964B00',
    Quota : '#FF9800',
    LEDiagnostics : 'green',
    InitialQuota : '#F57C00',
    Month : '#800080',
    Local : '#a206a2',
    Local2 : '#c152c1',
    Local3 : '#d099d0',
    SIT: 'purple',

    "Ex-Factory": "#3366cc",
    "DeliveredQTY": "#ADD8E6",
    "IQVIA - MIDAS": "#000000",
    "Fin.FC-based": "#aaaa11",
    "SC FC-based": "#cc8033",
    "Final Quota": "#FF9800",
    "Original Quota": "#F57C00",
    "Financial Forecast":"#006400",
    "SC Forecast" :"#FF00FF",
    "AI Forecast":"#EC5066",
    "GERS":"#a0a0a0",
    "Direct To Pharmacy Sales":"#993366",
    "Ex-Factory + Direct To Pharmacy Sales":"#8E4585",
    "IQVIA - MIDAS + Direct To Pharmacy Sales":"#DF73FF",
}

export const LocalGraphColour = ["#FDAB9F", "#bebdb8", "#bdb7ab", "#d9dddc", "#FE7D6A", "#d6cfc7", "#c7c6c1", "#FC9483", "#999da0", "#FC4C4E", "#4c3228", "#8b6c5c", "#d8cbc4", "#7600bc", "#6a4a3a", "#ca5cdd", "#bca89f", "#be2ed6", "#da8ee7", "#a000c8", "#9E4244", "#777b7e", "#793F0D", "#AC703D", "#C38E63", "#E49969", "#E5AE86", "#EEC5A9", "#9D9754", "#C7C397", "#B4A851", "#DFD27C", "#E7E3B5", "#846D74", "#B7A6AD", "#D3C9CE", "#d8bfd8", "#dda0dd", "#da70d6", "#ffc0cb", "#db7094", "#ffb6c1", "#915f6d", "#2c5e5d", "#4a9e9b", "#6eb1af", "#92c4c3", "#b6d8d7", "#428e8b", "#5c8caf", "#9dbacf", "#49708c"];
